<template>
  <div class="page">
    <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">
      <h2 class="page-title" style="margin:0;">{{ $t('menu.handlerClosed') }}</h2>
      <el-button @click="load" :loading="loading">{{ $t('common.refresh') }}</el-button>
    </div>

    <div class="glass-card" style="margin-top: 14px; padding: 14px;">
      <div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-bottom:12px;">
        <el-date-picker
          v-model="range"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="~"
          :start-placeholder="$t('kpi.from')"
          :end-placeholder="$t('kpi.to')"
          style="width: 320px;"
        />
        <el-button type="primary" class="btn-glass" plain icon="el-icon-search" @click="applyFilters" :loading="loading">{{ $t('common.search') }}</el-button>
      </div>

      <el-table :data="items" style="width:100%;" @row-click="open">
        <el-table-column prop="caseNo" :label="$t('field.caseNo')" width="140" />
        <el-table-column prop="title" :label="$t('field.title')" />
        <el-table-column :label="$t('field.status')" width="160">
          <template slot-scope="s">
            <span class="tag-pill">{{ caseStatusLabel(s.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="flowColumnLabel" width="220">
          <template slot-scope="s">
            <span class="tag-pill">{{ flowLabel(s.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('ticket.disputeLabel')" width="170">
          <template slot-scope="s">
            <span v-if="s.row.disputeStatus" :class="['tag-pill', s.row.disputeStatus === 'DISPUTE_CLOSED' ? '' : 'tag-pill--warn']">
              {{ disputeLabel(s.row) }}
            </span>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="closedAtLabel" :label="$t('field.closedAt')" width="190" />
      </el-table>

      <div style="display:flex;justify-content:flex-end;margin-top:12px;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          :page-sizes="[5,10,20,50]"
          @current-change="onPageChange"
          @size-change="onSizeChange"
        />
      </div>
    </div>

    <HandlerCaseDialog v-model="detailDialog" :case-no="currentCaseNo" :dispute-read-only="true" :read-only="true" />
  </div>
</template>

<script>
import { handlerClosedPage } from '../../api/tickets';
import HandlerCaseDialog from '../../components/HandlerCaseDialog.vue';
import { caseStatusLabel as formatCaseStatusLabel, disputeStatusLabel as formatDisputeStatusLabel, flowLabel as formatFlowLabel, localText as formatLocalText } from '../../utils/caseDisplay';

export default {
  name: 'HandlerClosed',
  components: { HandlerCaseDialog },
  data() {
    return { loading: false, items: [], total: 0, page: 1, pageSize: 10, range: [], detailDialog: false, currentCaseNo: '' };
  },
  created() {
    this.load();
    this.maybeOpenFromQuery();
  },
  computed: {
    version() {
      return this.$store.state.versions.handlerCases;
    },
    flowColumnLabel() {
      return formatLocalText(this, '流转', 'Flow');
    }
  },
  watch: {
    version() {
      this.load();
    },
    detailDialog(v) {
      if (v) return;
      if (this.$route.query && this.$route.query.caseNo) {
        const q = { ...this.$route.query };
        delete q.caseNo;
        this.$router.replace({ path: this.$route.path, query: q });
      }
    },
    '$route.query.caseNo'() {
      this.maybeOpenFromQuery();
    }
  },
  methods: {
    maybeOpenFromQuery() {
      const caseNo = this.$route.query && this.$route.query.caseNo ? String(this.$route.query.caseNo) : '';
      if (!caseNo) return;
      this.currentCaseNo = caseNo;
      this.detailDialog = true;
    },
    applyFilters() {
      this.page = 1;
      this.load();
    },
    onPageChange(p) {
      this.page = p;
      this.load();
    },
    onSizeChange(s) {
      this.pageSize = s;
      this.page = 1;
      this.load();
    },
    caseStatusLabel(row) {
      return formatCaseStatusLabel(this, row);
    },
    flowLabel(row) {
      return formatFlowLabel(this, row);
    },
    disputeLabel(row) {
      return formatDisputeStatusLabel(this, row);
    },
    async load() {
      if (!this.$store.state.user) return;
      this.loading = true;
      try {
        const from = this.range && this.range.length === 2 ? this.range[0] : undefined;
        const to = this.range && this.range.length === 2 ? this.range[1] : undefined;
        const r = await handlerClosedPage({ from, to, page: this.page - 1, size: this.pageSize });
        this.items = (r.items || []).map((x) => ({
          ...x,
          closedAtLabel: x.closedAt ? new Date(x.closedAt).toLocaleString() : '-'
        }));
        this.total = r.total || 0;
      } finally {
        this.loading = false;
      }
    },
    open(row) {
      if (!row || !row.caseNo) return;
      this.currentCaseNo = row.caseNo;
      this.detailDialog = true;
    }
  }
};
</script>
